import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import DoAsk from "./DoAsk";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

class IllnessList extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            signComment: null,
            showSignComment: false,
            showDoAsk: false,
            rowKey: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.execute({}, {withParams: true, withStyle: true}));
        } catch (e) {
            console.error(e);
        }
    }

    refresh = async () => {
        await this.props.dispatch(this.props.dataItem.refresh());
    }

    renderParams = (h) => {
        const showSignAll = this.props.AgreePers_GetSignAllForPO.getField(0, "IsEnableSignAll") === 1;
        return (<div className="row">
            <div className="col-md-12">
                {showSignAll &&
                    <div className="row">
                        <button className="btn btn-regular -goahead ml1ex"
                                onClick={this.signAll}>{i18next.t("Agreement_List_2")}
                        </button>
                    </div>
                }
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    doAsk = (row, event) => {
        event.preventDefault();

        const rowKey = this.props.dataItem.getRowKey(row);
        this.setState({showDoAsk: true, rowKey: rowKey});
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "DoAsk") {
            return (
                <div>
                    <label>
                        <a href="" rel="noopener noreferrer"
                           onClick={(event) => this.doAsk(cellParams.row, event)}
                           className="mr-2">{cellParams.row.DoAsk}</a>
                    </label>
                </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    render() {
        if (!this.props.dataItem.isInitialized)
            return null;
        return (
            <>
                {
                    this.state.showDoAsk &&
                    <DoAsk rowKey={this.state.rowKey} dispatch={this.props.dispatch}
                           dataItem={this.props.dataItem_SaveAsk}
                           dataItem_Params={this.props.dataItem_SaveAsk_Params}
                           onClose={() => {
                               this.setState({showDoAsk: false})
                           }}/>
                }
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-list'/> {i18next.t("Illness_List_1")}</>}
                                    showInstruction={false}
                                    showSplitterLine={true} canCollapse={false}>
                    <ComplexParam parentDataItem={this.props.dataItem}
                                  dataItem={this.props.dataItem_Params}
                                  renderParams={paramRender}
                                  showApplyButton={false} autoApplyParams={true}
                                  readOnly={false} showSearchBar={false}
                                  rootPath="/"/>
                    <span>&nbsp;</span>
                    <GridView dataItem={this.props.dataItem} renderCellEx={this.renderCellEx} readOnly={true}
                              useItemStyle={true}
                    />
                </PlaceholderWrapper>
            </>
        )
    }
}

IllnessList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    IllnessList_List_PO: PropTypes.object,
    IllnessList_List_PO_Params: PropTypes.object,
    dataItem_SaveAsk: PropTypes.object,
    dataItem_SaveAsk_Params: PropTypes.object
}

IllnessList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.docflowState.IllnessList_List_PO,
        dataItem_Params: state.docflowState.IllnessList_List_PO_Params,
        dataItem_SaveAsk: state.docflowState.IllnessListAsk_SaveAsk,
        dataItem_SaveAsk_Params: state.docflowState.IllnessListAsk_SaveAsk_Params
    }
}

export default connect(mapStateToProps)(IllnessList)